
import { Component } from "@angular/core";

@Component({
  selector: "iti-empty-layout",
  styleUrls: ["./empty-layout.component.scss"],
  template: `
    <div>
        <router-outlet></router-outlet>
    </div>
  `,
})
export class EmptyLayoutComponent { }